import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import type { HTMLAttributes } from 'vue';
    import { cn } from '@/lib/utils';
    import InputError from '@/components/InputError.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'SectionHeader',
  props: {
    class: {},
    error: {}
  },
  setup(__props: any) {

    const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(
            _unref(cn)(
                'border-secondary text-secondary flex gap-2 border-b pb-2 text-xs sm:items-center',
                props.class,
            )
        )
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})